<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <ActivityLog
            title="Beskeder"
            :entries="messages"
            :relations="relations"
            :relationId="spec.id"
            relationKind="specification"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ActivityLog from '@/components/ActivityLog.vue';

export default {
  name: 'SpecificationMessages',
  components: {
    ActivityLog
  },
  props: ['spec', 'relations'],
  data() {
    return {
      messages: []
    }
  },
  methods: {
    async getMessages() {
      const sectionIds = this.spec.groups.flatMap(group => group.sections.flatMap(section => section.id))

      this.messages = await this.$store.dispatch('messages/getMessages', [this.$route.params.specId, ...sectionIds]);
    }
  },
  mounted() {
    this.getMessages();
  }
}
</script>